<template>
	<div class="gb-additional-info">
		<div 
			v-for="info in additionalInfo" 
			v-bind:key="info.additional_info.code"
		>
			<div
				v-if="isShowAdditionalInfo(info.additional_info.code)">
			<template v-if="info.additional_info.isNumber">
				{{ info.additional_data.value
						? isNaN(Number(info.additional_data.value)) ? info.additional_data.value : Number(info.additional_data.value).toLocaleString()
						: info.additional_data.value }}
			</template>
			<template v-else-if="info.additional_info.isAddress" class="address">
				<a 
					:href="urlSearchMap(info.additional_data.value)" 
					v-on:click.stop= ""
					target="_blank" 
					rel="noopener noreferrer"
				>
					{{ info.additional_data.value }}
				</a>
			</template>
			<template v-else>
				{{ info.additional_data.value }}
			</template>
			</div>
		</div>
	</div>
</template>
<script>

import Util from '../classes/Util';

export default {
	name: "GBAdditionalInfo",
	props: [ 
		"project",
		"project_pinned"
	],
	methods: {
		display: function() {
			return true;
		},
		urlSearchMap: function(value) {
			return Util.urlSearchGoogleMap(value);
		},
		isShowAdditionalInfo: function(code) {
			let ret = false;
			if (this.project_pinned['2'][code]) {
				ret = true;
			}
			return ret;
		}
	},
	mounted: function() {
		this.display();
	},
	computed: {
		additionalInfo: function() {
			if(!this.project || !this.project.project_additional)
				return [];

			const ret = [];
			this.$store.getters.additionalInfo.forEach(add => {
				const data = this.project.project_additional.filter(pa => {
					return pa.additional_id == add.code;
				});
				if (data.length > 0) {
					ret.push({
						additional_info : add,
						additional_data : data[0],
					});
				}
			});

			return ret;
		},
	},
};
</script>
<style>
	.gb-additional-info {
		width: 100%;
		overflow: hidden;
		/*
		text-overflow: ellipsis;
		*/
		white-space: nowrap;
		font-size: .75em;
		margin-right: 3px;
	}
</style>
